import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Disclaimer from '../Disclaimer';
import RadioGroup from './../RadioGroup';
import Toggle from '../Toggle';
import { withTranslation, Trans } from 'react-i18next';
import { view02ImageOptions } from './views/view02'

class Deckanchor extends Component {
    constructor(props) {
        super(props);
        this.handleDeckChange = this.handleDeckChange.bind(this);
        this.handleBowOptionChange = this.handleBowOptionChange.bind(this);
        this.handleAnchorBowChange = this.handleAnchorBowChange.bind(this);
    }

    handleDeckChange(newValue) {
         let configuration = this.props.configuration;
         configuration.Deck = newValue;

         if (this.props.onChange) {
         this.props.onChange(configuration);
         }
    }

    handleBowOptionChange(event) {
        let configuration = this.props.configuration;
        configuration.BowOption = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleUpholsteryCockpitChange(newValue) {
        let configuration = this.props.configuration;
        configuration.UpholsteryCockpit = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleAnchorBowChange(newValue) {
        let configuration = this.props.configuration;
        configuration.AnchorBow = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }
      

    render() {
        let imageOptions = view02ImageOptions;

        let image = (
                <ConfiguratorImage boat="Xpower" configuration={this.props.configuration} options={imageOptions} />
        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{ position: 'relative' }}>

                    <h1><Trans defaults='Deck' /></h1>
                    <h2><Trans defaults='Deck material' /></h2>
                    <p><Trans defaults='You can choose between two different deck materials, the genunine teak and an optional Flexiteek finish.' /></p>
                    <RadioGroup options={this.props.DeckOptions} value={this.props.configuration.Deck} onChange={this.handleDeckChange} />

                    <h1><Trans defaults='Anchor' /></h1>
                    <h2><Trans defaults='Bow' /></h2>
                    <p><Trans defaults='The powerboat comes with a manual bow anchor as standard. Optional is an electrical retractable anchor.' /></p>

                    <RadioGroup options={this.props.AnchorBowOptions} value={this.props.configuration.AnchorBow} onChange={this.handleAnchorBowChange} />

                    <h2><Trans defaults='Accessories' /></h2>

                    <p><Trans defaults='You can have bow seat cushions (same upholstery as cockpit - adjustable in later step)' /></p>
                    <Toggle checked={this.props.configuration.BowOption.value === 2} value={this.props.configuration.BowOption} onChange={this.handleBowOptionChange}>
                        <Trans defaults='Cushions on bow deck' />
                    </Toggle>

                    <Disclaimer />


                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Deckanchor);


// WEBPACK FOOTER //
// ./src/Xpower/Deckanchor.js